import { useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import { useExcluirTabelaProcedimento } from "../hooks/useTabelaProcedimento";

const ExcluirTabelaDialog = ({ isOpen, onClose, tabelaId }) => {
  const cancelRef = useRef();
  const excluirTabela = useExcluirTabelaProcedimento();

  const handleConfirmar = () => {
    if (!tabelaId) return;
    excluirTabela.mutate(tabelaId, { onSuccess: onClose });
  };

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Excluir tabela de procedimentos
          </AlertDialogHeader>
          <AlertDialogBody>
            Tem certeza que deseja excluir esta tabela? Todos os itens vinculados a ela também serão removidos. Esta ação não pode ser desfeita.
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleConfirmar} ml={3} isLoading={excluirTabela.isPending}>
              Excluir
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ExcluirTabelaDialog;
